import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../configs/urlConfig"; // tvoj API base URL
import Utils from "../utils";
import Musterije from "../components/Musterije";

axios.defaults.withCredentials = true;

function User() {
    const { id } = useParams(); // uzima datum iz URL-a// uzima datum iz URL-a
    const navigate = useNavigate();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        console.log('rrrrrrrrrrrrrrrrrrrrrrr', id)
        const fetchData = async () => {
            try {
                setLoading(true);
                setError("");
                console.log('bbbbbbbbbbbbbbbbbbbbbbbb', id)
                // šaljemo datum u backend
                const response = await axios.get(`${API}/get-customer-by-id/?id=${id}`, Utils.getUserToken());
                setData(response.data); // pretpostavljam da backend vraća objekat sa poljem "payouts"
            } catch (err) {
                console.error(err);
                setError("Greška prilikom dohvata podataka");
            } finally {
                setLoading(false);
            }
        };

        if (id) {
            fetchData();
        }
    }, [id]);

    if (loading)
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                Učitavanje...
            </div>
        );

    if (error)
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <p className="text-danger">{error}</p>
            </div>
        );

    if (!data || !data.payouts)
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <p>Nema podataka</p>
            </div>
        );





    return (
        <div className="container mt-2">
            <Musterije data={data} setData={setData} user={true} />
            <div
                className="d-flex justify-content-center align-items-center w-100"
                style={{
                    zIndex: 20,
                    position: 'fixed',
                    left: 0,
                    bottom: 0,
                    backgroundColor: 'white',
                    padding: '10px',
                }}
            >
                <button
                    type="button"
                    className="btn btn-primary btn-sm desktop-add-btn"
                    onClick={() => navigate('/')}
                >
                    Home
                </button>
            </div>
        </div>
    );
}

export default User;